module.exports = __webpack_public_path__ + "static/img/book.754adda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book.svg
// module id = DFmh
// module chunks = 0